module.exports = __webpack_public_path__ + "static/media/hand-money.14193c9f.svg";